import { getAccessToken } from "@/services/auth";

export const authorizedFetch = async (url: string, requestInit: RequestInit = {}) => {
  console.debug(`calling ${url}`);
  const accessToken = await getAccessToken();

  if (!accessToken) throw new Error("No access token.");

  const result = await window.fetch(url, {
    ...requestInit,
    headers: {
      ...(requestInit.headers || {}),
      Authorization: `Bearer ${accessToken}`,
    },
  });

  if (!result.ok) {
    throw result;
  }
  return result;
};
